var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("StoreHeader"),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0" },
        [
          _c("LeftStoreDetailNav"),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { id: "header", cols: "12" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0",
                      attrs: { cols: "12", id: "header_body" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0",
                          attrs: { cols: "12", id: "main_content_maxwidthset" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-4 pl-0 pr-0",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "back_clean_btn ma-0 pa-2 current_tap_btn",
                                          attrs: {
                                            width: "9rem",
                                            height: "auto",
                                            elevation: "0",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.ta("numberOfCustomers")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pr-2",
                                          attrs: { cols: "auto" },
                                        },
                                        [_vm._v(_vm._s(_vm.ta("period")) + ":")]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 mr-4",
                                          staticStyle: { width: "14rem" },
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-select", {
                                            class: {
                                              select_font:
                                                _vm.fromToString != "",
                                            },
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: _vm.periodList,
                                              "hide-details": "",
                                              outlined: "",
                                              height: 30,
                                              "item-text": "label",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.period,
                                              callback: function ($$v) {
                                                _vm.period = $$v
                                              },
                                              expression: "period",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pr-2",
                                          attrs: { cols: "auto" },
                                        },
                                        [_vm._v(_vm._s(_vm.ta("mode")) + ":")]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          staticStyle: { width: "8rem" },
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: _vm.modeList,
                                              dense: "",
                                              "hide-details": "",
                                              outlined: "",
                                              "item-text": "label",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.mode,
                                              callback: function ($$v) {
                                                _vm.mode = $$v
                                              },
                                              expression: "mode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("AnalyticsDatePicker", {
                            attrs: {
                              mode: _vm.mode,
                              leftSide: _vm.leftSide,
                              num: _vm.axisNum,
                              period: _vm.period,
                              start: _vm.startDate,
                              end: _vm.endDate,
                            },
                            on: { update: _vm.onAxisUpdated },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pa-0 pb-10",
                  staticStyle: { "font-weight": "bold" },
                  attrs: { id: "main_content_maxwidthset", cols: "12" },
                },
                [
                  _vm.weatherVisible
                    ? _c("AnalyticsWeather", {
                        attrs: {
                          weatherLoading: _vm.weatherLoading,
                          mode: _vm.mode,
                          axisNum: _vm.axisNum,
                          weatherDate: _vm.weatherDate,
                        },
                      })
                    : _vm._e(),
                  _c("AnalyticsBox", {
                    attrs: {
                      mode: _vm.mode,
                      period: _vm.period,
                      downloadMode: _vm.downloadMode,
                      downloadPeriod: _vm.downloadPeriod,
                      startDate: _vm.startDate,
                      endDate: _vm.endDate,
                      leftSide: _vm.leftSide,
                      params: _vm.params,
                      axisNum: _vm.axisNum,
                      unisCustomerCd: _vm.unisCustomerCd,
                    },
                  }),
                ],
                1
              ),
              _c("FromToDatePickerDialog", {
                attrs: { dialogVisible: _vm.fromToDialogVisible },
                on: {
                  visible: _vm.fromToDialogVisibleFunc,
                  fromtoEvent: _vm.fromtoEventFunc,
                  cancel: _vm.fromToCancelFunc,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }